export const solutionPages = [
    {
        id: "repair",
        title: "Service & Repair",
        borderColor: "#cfa700",
        ctaColor: "#7a6200",
        ctaText: "View Products",
        summary: "Technicians do not have time for trial-and-error hardware swapping. Ultra-X tools help isolate failures quickly and consistently.",
    },
    {
        id: "customer",
        title: "Customer Support",
        borderColor: "#024561",
        ctaColor: "#024561",
        ctaText: "View Products",
        summary: "Customer support solutions for out-of-box and custom service environments across the PC lifecycle.",
    },
    {
        id: "recycle",
        title: "Refurbishment & Recycling",
        borderColor: "#014314",
        ctaColor: "#014314",
        ctaText: "View Products",
        summary: "Use the same validation technology during refurbishment for consistent testing and faster quality control.",
    },
    {
        id: "development",
        title: "Developer",
        borderColor: "#5e2701",
        ctaColor: "#5e2701",
        ctaText: "View Products",
        summary: "Validation tools that help engineers isolate hardware issues on prototype platforms and components.",
    },
    {
        id: "manufacture",
        title: "Manufacturing",
        borderColor: "#370136",
        ctaColor: "#370136",
        ctaText: "View Products",
        summary: "Customized diagnostic workflows for manufacturing and assembly environments that need repeatable results.",
    },
    {
        id: "custom",
        title: "Create Your Own Solution",
        borderColor: "#002F52",
        ctaColor: "#002F52",
        ctaText: "View All Products",
        summary: "Build your own tool set from the full Ultra-X catalog and tailor the workflow to your organization.",
    },
];

export const organizationProfile = {
    name: "Ultra-X Diagnostics",
    legalName: "Ultra-X Inc.",
    phone: "+1-408-261-7090",
    email: "websupport@uxd.com",
    address: {
        streetAddress: "2119 De La Cruz Blvd.",
        addressLocality: "Santa Clara",
        addressRegion: "CA",
        postalCode: "95050",
        addressCountry: "US",
    },
    sameAs: [
        "https://www.facebook.com/UltraXDiagnostics",
        "https://www.pinterest.com/ultraxinc/",
        "https://x.com/ultra_x_inc",
        "https://www.youtube.com/user/pcdiag",
    ],
    logoPath: "/assets/icons/favicon/android-chrome-512x512.png",
};
